<template>
    <div>
        <b-form-checkbox
            :id="name"
            v-model="status"
            :size="size"
            :unchecked-value="false"
            :value="true"
            name="name"
        >
            {{ label }}
        </b-form-checkbox>
        <!--        <div>State: <strong>{{ status }}</strong></div>-->
    </div>
</template>

<script>
import {BFormCheckbox} from "bootstrap-vue";

export default {
    name: "CheckBox",
    components: {
        BFormCheckbox
    },
    data() {
        return {
            status: this.checked || false
        }
    },
    props: {
        size: {
            type: String,
            default: "sm"
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: "Checkbox label"
        },
        getValue: {
            type: Function,
            default: () => {
                console.log("Function getValue was not set!")
            }
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        status(newVal, oldVal) {
            this.getValue(this.name, newVal);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/common/BaseCheckBox.vue